// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromoActionsControlPage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.PromoActionsControlPage .titleBlock {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  background: #fff;
  padding-top: 43px;
  padding-left: 40px;
  padding-bottom: 27px;
}
.PromoActionsControlPage .titleBlock span {
  font-family: "Montserrat Regular";
  font-weight: 500;
  font-size: 24px;
}
.PromoActionsControlPage .promoActionsGrid {
  margin-top: 100px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  width: 90%;
  margin: auto;
  margin-top: 70px;
}
.PromoActionsControlPage .promoCard {
  position: relative;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #ffffff;
}
.PromoActionsControlPage .promoCard .promoImageWrapper {
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.PromoActionsControlPage .promoCard .promoImageWrapper .editIcon {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
  font-size: 18px;
  color: #1890ff;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
}
.PromoActionsControlPage .promoCard .promoImageWrapper .editIcon:hover {
  color: #40a9ff;
}
.PromoActionsControlPage .promoCard .promoImageWrapper .deleteIcon {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  font-size: 18px;
  color: red;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
}
.PromoActionsControlPage .promoCard .promoImageWrapper .deleteIcon:hover {
  color: darkred;
}
.PromoActionsControlPage .promoCard .promoInfo {
  padding: 8px;
}
.PromoActionsControlPage .promoCard .promoTitle {
  font-weight: bold;
  font-size: 14px;
}
.PromoActionsControlPage .promoCard .promoDescription,
.PromoActionsControlPage .promoCard .promoCity {
  font-size: 12px;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/PromoActionsControlPage/PromoActionsControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AACI;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;AACN;AAGE;EACE,iBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAIE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAFJ;AAII;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAFN;AAIM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAFR;AAIQ;EACE,cAAA;AAFV;AAMM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAJR;AAMQ;EACE,cAAA;AAJV;AASI;EACE,YAAA;AAPN;AAUI;EACE,iBAAA;EACA,eAAA;AARN;AAWI;;EAEE,eAAA;EACA,WAAA;AATN","sourcesContent":[".PromoActionsControlPage {\n  padding-left: 281px;\n  background: #EFF0F4;\n  width: 100%;\n  height: 100vh;\n\n  .titleBlock {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    background: #fff;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n\n    span {\n      font-family: \"Montserrat Regular\";\n      font-weight: 500;\n      font-size: 24px;\n    }\n  }\n\n  .promoActionsGrid {\n    margin-top: 100px;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 16px;\n    width: 90%;\n    margin: auto;\n    margin-top: 70px;\n  }\n\n  .promoCard {\n    position: relative;\n    border: 1px solid #f0f0f0;\n    border-radius: 8px;\n    overflow: hidden;\n    background-color: #ffffff;\n\n    .promoImageWrapper {\n      position: relative;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n\n      .editIcon {\n        position: absolute;\n        top: 8px;\n        left: 8px;\n        z-index: 10;\n        font-size: 18px;\n        color: #1890ff;\n        background: rgba(255, 255, 255, 0.8);\n        border-radius: 50%;\n        padding: 4px;\n        cursor: pointer;\n\n        &:hover {\n          color: #40a9ff;\n        }\n      }\n\n      .deleteIcon {\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        z-index: 10;\n        font-size: 18px;\n        color: red;\n        background: rgba(255, 255, 255, 0.8);\n        border-radius: 50%;\n        padding: 4px;\n        cursor: pointer;\n\n        &:hover {\n          color: darkred;\n        }\n      }\n    }\n\n    .promoInfo {\n      padding: 8px;\n    }\n\n    .promoTitle {\n      font-weight: bold;\n      font-size: 14px;\n    }\n\n    .promoDescription,\n    .promoCity {\n      font-size: 12px;\n      color: #555;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PromoActionsControlPage": `PromoActionsControlPage`,
	"titleBlock": `titleBlock`,
	"promoActionsGrid": `promoActionsGrid`,
	"promoCard": `promoCard`,
	"promoImageWrapper": `promoImageWrapper`,
	"editIcon": `editIcon`,
	"deleteIcon": `deleteIcon`,
	"promoInfo": `promoInfo`,
	"promoTitle": `promoTitle`,
	"promoDescription": `promoDescription`,
	"promoCity": `promoCity`
};
export default ___CSS_LOADER_EXPORT___;
